import script from "./CustomerDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerDetails.vue?vue&type=script&setup=true&lang=js"

import "./CustomerDetails.vue?vue&type=style&index=0&id=35b8c7b7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35b8c7b7"]])

export default __exports__